export default "__VITE_ASSET__BQCXtU_X__"